module.exports = __webpack_public_path__ + "img/SEJ_Eventos_texto largo.f8d335ed.svg";